import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { ToggleList } from '../interactions/ToggleList.jsx'

/**
 * QuestionsRaisedCard — session-questions (catalog #11, non-core).
 *
 * Q-log with status pill open/answered. Conditional answer TextField
 * shown when status='answered'.
 *
 * Reuses ToggleList interaction with toggleMode='status'.
 */

export function QuestionsRaisedCard({ text = '', onChange, disabled = false }) {
  let items = []
  try {
    if (text) items = JSON.parse(text)
  } catch {
    items = []
  }

  function handleChange({ items: next }) {
    onChange?.(JSON.stringify(next))
  }

  return (
    <CardFrame
      kind="session"
      icon="?"
      iconClass="mustard"
      title="Questions raised"
      prompt="What questions came up?"
      state={disabled ? 'locked' : items.length > 0 ? 'filled' : 'empty'}
      data-testid="session-card-questions-raised"
      className="session-card"
    >
      <ToggleList
        items={items}
        onChange={handleChange}
        maxItems={20}
        readOnly={disabled}
        toggleMode="status"
      />
    </CardFrame>
  )
}
